export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
              <i className="ri-mail-send-line text-accent-600 text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              无论你是漫画创作者、内容合作方，还是有话想说的读者，欢迎随时与我们取得联系。
            </p>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6">
            <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-chat-smile-2-line text-primary-600 text-3xl"></i>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">投稿与合作咨询</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                我们欢迎优质漫画内容的投稿与合作。无论是原创漫画、翻译作品还是内容授权合作，都可以通过以下方式联系我们。我们的编辑团队会在 48 小时内给予回复。
              </p>
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3">
                <a
                  href="mailto:contact@aimanhua.example.com"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                  发送邮件
                </a>
                <span className="text-sm text-foreground-400">contact@aimanhua.example.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}